export const DEFAULT_TAB_TITLE = 'Autodesk Forma';
